import { render } from "./SmsTemplatesEditPage.vue?vue&type=template&id=71a5861c"
import script from "./SmsTemplatesEditPage.vue?vue&type=script&lang=js"
export * from "./SmsTemplatesEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__